<template>
  <div>
    <!-- <abbvie-header>AbbVie商业流向管理系统</abbvie-header> -->
    <!-- <position-switcher @switched="handlePositionSwitched" /> -->
    <van-notice-bar
      :scrollable="noticeContent.length > 25"
      :text="noticeContent"
      v-if="noticeContent"
      @click="showNotice = true"
    />
    <div class="main">
      <!-- ddi -->
      <div class="ddi">
        <div class="ddi-title">
          <div class="title-left">
            <div class="logo"><img src="/ddi_logo.png" />DDI</div>
            <div class="date">
              <span>数据截至：{{ moment(ddiDate.salesBusinessDate).format('YYYY/MM/DD') }}</span>
              <!-- ddi气泡提示框 -->
              <van-popover v-model="ddiPopover" trigger="click">
                <div class="tips">
                  <div>1.进度=实际 / 指标</div>
                  <div>2.时间进度=数据截止日期 / 对应月自然天数</div>
                  <div>3.IMM实际数量为未拆分的医院销量</div>
                </div>
                <template #reference>
                  <van-icon name="question" size="16px" />
                </template>
              </van-popover>
              <!-- <van-icon name="question" size="16px" /> -->
            </div>
          </div>
          <div class="detail">
            <van-button class="btn-active" :disabled="loading" @click="showQty = !showQty"
              >{{ showQty ? '数量' : '金额' }}<van-icon class="sort-icon" name="sort"
            /></van-button>
            <van-button class="btn-active ml10" :disabled="loading" @click="isTarget = !isTarget"
              >{{ isTarget ? '目标' : '全量' }}<van-icon class="sort-icon" name="sort"
            /></van-button>
          </div>
        </div>
        <div class="ddi-content" @click="openRouter('/ddiDailys')" v-if="!showQty">
          <div class="info">
            <div class="title">实际金额</div>
            <div class="content">{{ ddiInfo.amountSum | NumberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">指标金额</div>
            <div class="content">{{ ddiInfo.targetAmount | NumberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">去年同期金额</div>
            <div class="content">{{ ddiLastYearInfo.amountSum | NumberFormat(false) }}</div>
          </div>
        </div>
        <div class="ddi-content" @click="openRouter('/ddiDailys')" v-else>
          <div class="info">
            <div class="title">实际数量</div>
            <div class="content">{{ ddiInfo.actualVendorQty | NumberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">指标数量</div>
            <div class="content">{{ ddiInfo.targetVendorQty | NumberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">去年同期数量</div>
            <div class="content">{{ ddiLastYearInfo.actualVendorQty | NumberFormat(false) }}</div>
          </div>
        </div>
        <div class="ddi-schedule" @click="openRouter('/ddiDailys')">
          <template v-if="!showQty">
            <div class="schedule">
              <div class="schedule-title">进度</div>
              <van-circle
                v-model="ddiInfo.yieldRateByAmount"
                :stroke-width="60"
                color="#25B6EE"
                layer-color="#F2F2F2"
                size="75px"
                :rate="ddiInfo.yieldRateByAmount"
                :speed="100"
                :text="scheduleText"
              >
                <template slot="default">
                  <div class="schedule-text">{{ scheduleText }}</div>
                </template>
              </van-circle>
            </div>
            <div class="schedule">
              <div class="schedule-title">QTD进度</div>
              <van-circle
                v-model="ddiQtdInfo.yieldRateByAmount"
                :stroke-width="60"
                color="#25B6EE"
                layer-color="#F2F2F2"
                size="75px"
                :rate="ddiQtdInfo.yieldRateByAmount"
                :speed="100"
                :text="ddiQtdText"
              >
                <template slot="default">
                  <div class="schedule-text">{{ ddiQtdText }}</div>
                </template>
              </van-circle>
            </div>
          </template>
          <template v-else>
            <div class="schedule">
              <div class="schedule-title">进度</div>
              <van-circle
                v-model="ddiInfo.yieldRate"
                :stroke-width="60"
                color="#25B6EE"
                layer-color="#F2F2F2"
                size="75px"
                :rate="ddiInfo.yieldRate"
                :speed="100"
                :text="scheduleText"
              >
                <template slot="default">
                  <div class="schedule-text">{{ scheduleText }}</div>
                </template>
              </van-circle>
            </div>
            <div class="schedule">
              <div class="schedule-title">QTD进度</div>
              <van-circle
                v-model="ddiQtdInfo.yieldRate"
                :stroke-width="60"
                color="#25B6EE"
                layer-color="#F2F2F2"
                size="75px"
                :rate="ddiQtdInfo.yieldRate"
                :speed="100"
                :text="ddiQtdText"
              >
                <template slot="default">
                  <div class="schedule-text">{{ ddiQtdText }}</div>
                </template>
              </van-circle>
            </div>
          </template>
          <div class="schedule">
            <div class="schedule-title">时间进度</div>
            <van-circle
              v-model="ddiInfo.dateSchedule"
              :stroke-width="60"
              color="#25B6EE"
              layer-color="#F2F2F2"
              size="75px"
              :rate="ddiInfo.dateSchedule"
              :speed="100"
              :text="dateScheduleText"
            >
              <template slot="default">
                <div class="schedule-text">{{ dateScheduleText }}</div>
              </template>
            </van-circle>
          </div>
        </div>
      </div>
      <!-- 预估数量 -->
      <div class="estimate">
        <div class="estimate-title">
          <div class="title-left">
            <div class="logo"><img src="/estimate_logo.png" />预估数量</div>
            <div class="date">
              <span v-if="estimateVersion.fillInEndTime">
                填写截止至：{{ estimateVersion.fillInEndTime | date('MM/DD HH:mm') }}
              </span>
              <span v-else>不在窗口期</span>
            </div>
          </div>
          <van-popover v-model="showEstimateVersion" placement="bottom-end" trigger="click">
            <template #default>
              <div class="estimate-version-list">
                <div
                  class="estimate-version"
                  v-for="(item, index) in estimateVersionList"
                  @click="handleEstimateVersion(item)"
                >
                  <div class="estimate-version-item">{{ item.ym }} {{ item.version }}</div>
                </div>
              </div>
            </template>

            <template #reference>
              <div class="estimate-detail">{{ estimateVersion.ym }} {{ estimateVersion.version }}</div>
            </template>
          </van-popover>
        </div>
        <div class="estimate-content" @click="openRouter('/estimate')" v-if="!showQty">
          <div class="info">
            <div class="title">预估金额(标准)</div>
            <div class="content">{{ estimateInfo.standardEstimateAmount | numberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">指标金额</div>
            <div class="content">{{ estimateInfo.targetAmount | numberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">预估达成</div>
            <div class="content">{{ estimateInfo.estimateAchievementAmount | numberFormat(false, true) }}</div>
          </div>
        </div>
        <div class="estimate-content" @click="openRouter('/estimate')" v-else>
          <div class="info">
            <div class="title">预估数量(标准)</div>
            <div class="content">{{ estimateInfo.standardEstimateQty | numberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">指标数量</div>
            <div class="content">{{ estimateInfo.targetQty | numberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">预估达成</div>
            <div class="content">{{ estimateInfo.estimateAchievementQty | numberFormat(false, true) }}</div>
          </div>
        </div>
      </div>
      <!-- 月度 -->
      <div class="kpi">
        <div class="kpi-title">
          <div class="title-left">
            <div class="logo">
              <img src="/kpi_logo.png" />月度<span style="font-size: 12px">&nbsp;(流向申诉核对)</span>
            </div>
            <div class="date">
              <span>数据截至：{{ moment(kpiDate.salesBusinessDate).format('YYYY/MM') }}</span>
              <!-- 月度气泡提示框 -->
              <van-popover v-model="kpiPopover" trigger="click">
                <div class="tips">
                  <div>1.达成率=实际 / 指标</div>
                  <div>2.YoY=（当年该月实际-上年同期实际）/上年同期实际</div>
                </div>
                <template #reference>
                  <van-icon name="question" size="16px" />
                </template>
              </van-popover>
            </div>
          </div>
          <!-- <div class="detail" @click="openRouter('/monthlySales')">查看详情<van-icon name="arrow" /></div> -->
        </div>
        <div class="kpi-content" @click="openRouter('/monthlySales')" v-if="!showQty">
          <div class="info">
            <div class="title">实际金额</div>
            <div class="content">{{ kpiInfo.amountSum | NumberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">指标金额</div>
            <div class="content">{{ kpiInfo.targetAmount | NumberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">去年同期金额</div>
            <div class="content">{{ kpiLastYearInfo.amountSum | NumberFormat(false) }}</div>
          </div>
        </div>
        <div class="kpi-content" @click="openRouter('/monthlySales')" v-else>
          <div class="info">
            <div class="title">实际数量</div>
            <div class="content">{{ kpiInfo.actualVendorQty | numberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">指标数量</div>
            <div class="content">{{ kpiInfo.targetVendorQty | NumberFormat(false) }}</div>
          </div>
          <div class="info">
            <div class="title">去年同期数量</div>
            <div class="content">{{ kpiLastYearInfo.actualVendorQty | NumberFormat(false) }}</div>
          </div>
        </div>
        <div class="kpi-schedule" @click="openRouter('/monthlySales')">
          <template v-if="!showQty">
            <div class="schedule">
              <div class="schedule-title">达成率</div>
              <van-circle
                v-model="kpiInfo.yieldRateByAmount"
                :stroke-width="60"
                color="#1AB394"
                layer-color="#F2F2F2"
                size="75px"
                :rate="kpiInfo.yieldRateByAmount"
                :speed="100"
                :text="reachRateText"
              >
                <template slot="default">
                  <div class="schedule-text">{{ reachRateText }}</div>
                </template>
              </van-circle>
            </div>
            <div class="schedule">
              <div class="schedule-title">QTD进度</div>
              <van-circle
                v-model="kpiQtdInfo.yieldRateByAmount"
                :stroke-width="60"
                color="#1AB394"
                layer-color="#F2F2F2"
                size="75px"
                :rate="kpiQtdInfo.yieldRateByAmount"
                :speed="100"
                :text="kpiQtdText"
              >
                <template slot="default">
                  <div class="schedule-text">{{ kpiQtdText }}</div>
                </template>
              </van-circle>
            </div>
          </template>
          <template v-else>
            <div class="schedule">
              <div class="schedule-title">达成率</div>
              <van-circle
                v-model="kpiInfo.yieldRate"
                :stroke-width="60"
                color="#1AB394"
                layer-color="#F2F2F2"
                size="75px"
                :rate="kpiInfo.yieldRate"
                :speed="100"
                :text="reachRateText"
              >
                <template slot="default">
                  <div class="schedule-text">{{ reachRateText }}</div>
                </template>
              </van-circle>
            </div>
            <div class="schedule">
              <div class="schedule-title">QTD进度</div>
              <van-circle
                v-model="kpiQtdInfo.yieldRate"
                :stroke-width="60"
                color="#1AB394"
                layer-color="#F2F2F2"
                size="75px"
                :rate="kpiQtdInfo.yieldRate"
                :speed="100"
                :text="kpiQtdText"
              >
                <template slot="default">
                  <div class="schedule-text">{{ kpiQtdText }}</div>
                </template>
              </van-circle>
            </div>
          </template>
          <div class="schedule">
            <div class="schedule-title">YoY</div>
            <van-circle
              v-model="kpiLastYearInfo.yoy"
              :stroke-width="60"
              color="#1AB394"
              layer-color="#F2F2F2"
              size="75px"
              :rate="kpiLastYearInfo.yoy"
              :speed="100"
              :text="yoyText"
            >
              <template slot="default">
                <div class="schedule-text">{{ yoyText }}</div>
              </template>
            </van-circle>
          </div>
        </div>
      </div>
      <van-collapse v-model="activeNames" :border="false">
        <!-- 流向申诉 -->
        <div class="appeal" v-has="'mobile:flow:flow_appeal'">
          <van-collapse-item name="1" :border="false">
            <template #title>
              <div class="appeal-title">
                <div class="title-left">
                  <div class="logo"><img src="/appeal_logo.png" />流向申诉</div>
                  <div class="date">
                    <span>
                      <span v-if="appealDate.isWithinAppeal">申诉截止至：</span>{{ appealDate.appealDeadline }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <div class="appeal-content" @click="openRouter('/amountAppeals')">
              <div class="current">
                当期已生效/已提交<span>{{ appealStatus.effective }}/{{ appealStatus.totalCount }}</span>
              </div>
              <div class="all">
                <div>
                  核查中<span>{{ appealStatus.underVerification }}</span>
                </div>
                <div>
                  已拒绝<span>{{ appealStatus.rejected }}</span>
                </div>
                <div>
                  已确认<span>{{ appealStatus.confirmed }}</span>
                </div>
              </div>
            </div>
          </van-collapse-item>
        </div>
        <!-- 运维日历 -->
        <div class="calendar">
          <van-collapse-item name="2" :border="false">
            <template #title>
              <div class="calendar-title">
                <div class="title-left">
                  <div class="logo"><img src="/calendar_logo.png" />运维日历</div>
                  <div class="date">
                    <span>{{ moment().format('YYYY/MM') }}</span>
                  </div>
                </div>
              </div>
            </template>
            <img :src="calendarUrl" v-if="calendarUrl" @click="previewImg" />
            <div class="non-img" v-else>暂无数据</div>
          </van-collapse-item>
        </div>
      </van-collapse>
    </div>
    <!-- 切换岗位按钮 -->
    <div class="switch-post" @click="getPerationalPost" v-if="isRegionalAssistant">切换岗位</div>
    <el-dialog title="请选择岗位" :visible="showPostDialog" width="95%" @close="showPostDialog = false">
      <div class="tree">
        <el-tree
          ref="tree"
          v-loading="switchLoading"
          :data="filteredTree"
          :props="props"
          :default-checked-keys="postKey"
          node-key="key"
          :expand-on-click-node="false"
          default-expand-all
          check-on-click-node
          check-strictly
          show-checkbox
          @check-change="handleCheckChange"
        >
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 100%" type="primary" round :loading="switchLoading" @click="switchLogin"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 通知弹窗 -->
    <el-dialog title="通知" :visible="showNotice" width="95%" @close="showNotice = false">
      <div>{{ noticeContent }}</div>
      <el-button style="width: 100%; margin-top: 20px" type="primary" round @click="showNotice = false">
        确 定
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction, downFile } from '@/api/manage'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import PositionSwitcher from '@/components/PositionSwitcher.vue'
import moment from 'moment'
import { get } from 'lodash'
export default {
  components: {
    PositionSwitcher
  },
  data() {
    return {
      moment,
      loading: false, // 切换按钮是否禁用
      ddiPopover: false, // ddi气泡提示框
      kpiPopover: false, // 月度气泡提示框
      showQty: true, // 数量金额展示信息
      isTarget: false, // 目标全量展示信息
      activeNames: [],
      scheduleText: '',
      qtyText: '',
      amountText: '',
      dateScheduleText: '',
      reachRateQtyText: '',
      reachRateAmountText: '',
      reachRateText: '',
      qtyYoy: '',
      amountYoy: '',
      yoyText: '',
      ddiDate: {}, // ddi数据截至时间
      ddiInfo: {}, // ddi信息
      ddiLastYearInfo: {}, // ddi去年同期信息
      ddiQtdInfo: {}, // ddi QTD信息
      ddiQtdText: '', // ddi QTD进度文字
      kpiDate: {}, // 月度数据截至时间
      kpiInfo: {}, // 月度信息
      kpiLastYearInfo: {}, // 月度去年同期信息
      kpiQtdInfo: {}, // 月度 QTD信息
      kpiQtdText: '', // 月度 QTD进度文字
      appealDate: {}, // 流向申诉截至日期
      appealStatus: {}, // 流向申诉状态信息
      isAppealStatus: true, // 是否有查看申诉权限
      calendarUrl: '', // 运维日历
      territoryType: null, // 用户权限
      switchLoading: false, // 切换岗位按钮是否禁用
      isRegionalAssistant: false, // 是否是区域助理
      showPostDialog: false, // 是否显示岗位选择弹窗
      postData: [], // 岗位数据
      postKey: [], // 默认选中的岗位key
      chooseIdList: [], // 用户的岗位ID列表
      checkedKeys: [], // 选中的岗位key
      selectedPostNode: null, // 选中的岗位节点
      props: {
        label: 'title',
        children: 'children'
      },
      noticeContent: null, // 消息通知内容
      showNotice: false, // 是否显示消息通知弹窗
      showEstimateVersion: false, // 是否预估弹窗
      estimateVersionList: [], // 预估版本列表
      estimateVersion: {}, // 当前选择的预估版本
      estimateInfo: {} // 预估信息
    }
  },
  mounted() {
    this.getNotice() // 获取消息通知
    this.ddiRefreshDate()
    this.kpiRefreshDate()
    this.getAppealDate()
    this.getMaintenanceCalendar()
    this.getEstimateVersion() // 获取预估版本列表
    this.territoryType = Vue.ls.get('territoryType')
    this.isRegionalAssistant = Vue.ls.get('isRegionalAssistant')
  },
  watch: {
    showQty(val) {
      if (val) {
        this.scheduleText = this.qtyText
        this.reachRateText = this.reachRateQtyText
        this.kpiLastYearInfo.yoy = this.qtyYoy
        this.yoyText = (((this.qtyYoy || 0) * 100) / 100).toFixed(0) + '%'
        // 更新QTD进度文字（从原始值重新计算）
        this.ddiQtdText = this.ddiQtdInfo.targetVendorQty
          ? ((this.ddiQtdInfo._yieldRate || 0) * 100).toFixed(0) + '%'
          : '-'
        this.kpiQtdText = this.kpiQtdInfo.targetVendorQty
          ? ((this.kpiQtdInfo._yieldRate || 0) * 100).toFixed(0) + '%'
          : '-'
      } else {
        this.scheduleText = this.amountText
        this.reachRateText = this.reachRateAmountText
        this.kpiLastYearInfo.yoy = this.amountYoy
        this.yoyText = (((this.amountYoy || 0) * 100) / 100).toFixed(0) + '%'
        // 更新QTD进度文字（从原始值重新计算）
        this.ddiQtdText = this.ddiQtdInfo.targetAmount
          ? ((this.ddiQtdInfo._yieldRateByAmount || 0) * 100).toFixed(0) + '%'
          : '-'
        this.kpiQtdText = this.kpiQtdInfo.targetAmount
          ? ((this.kpiQtdInfo._yieldRateByAmount || 0) * 100).toFixed(0) + '%'
          : '-'
      }
    },
    isTarget(val) {
      this.loading = true
      this.ddiRefreshDate()
      this.kpiRefreshDate()
    }
  },
  computed: {
    // 将数字数组转为Set提升查询效率
    idFilterSet() {
      return new Set(this.chooseIdList)
    },

    // 过滤后的树数据
    filteredTree() {
      return this.deepFilter(this.postData)
    }
  },
  methods: {
    // 获取消息通知
    getNotice() {
      getAction('/sip/mobile/wxAppMessage/lastOne').then(res => {
        console.log('获取消息通知------', res)
        if (res.code == 200) {
          this.noticeContent = res.result.msgContent
        }
      })
    },

    // 查看详情
    openRouter(path) {
      if (path === '/ddiDailys') {
        // 触发埋点
        this.$sensors.track('ButtonClicked', {
          $element_type: 'div',
          $url_path: '/dataBoard',
          $element_content: 'DDI卡片'
        })
      } else if (path === '/monthlySales') {
        // 触发埋点
        this.$sensors.track('ButtonClicked', {
          $element_type: 'div',
          $url_path: '/dataBoard',
          $element_content: '月度卡片'
        })
      } else {
        // 触发埋点
        this.$sensors.track('ButtonClicked', {
          $element_type: 'div',
          $url_path: '/dataBoard',
          $element_content: '申诉卡片'
        })
      }
      this.$router.push({ path })
    },
    // 获取预估版本列表
    getEstimateVersion() {
      getAction('/sip/estimate/overview/mobile/versionList').then(res => {
        console.log('获取预估版本列表------', res)
        if (res.success) {
          this.estimateVersionList = res.result || []
          if (this.estimateVersionList.length == 0) {
            this.estimateVersion = {
              estimateWindowId: null,
              fillInEndTime: null,
              isWindowPeriod: false,
              version: null,
              ym: null
            }
          } else {
            this.estimateVersion = this.estimateVersionList[0]
            this.getEstimateInfo(this.estimateVersion.ym, this.estimateVersion.version)
          }
        }
      }).catch(error => {
        console.error('获取预估版本列表失败------', error)
      })
    },
    // 切换预估版本
    handleEstimateVersion(record) {
      console.log('切换预估版本', record)
      this.estimateVersion = record
      this.getEstimateInfo(record.ym, record.version)
      this.$toast('切换成功')
      this.showEstimateVersion = false
    },
    // 获取预估信息
    getEstimateInfo(ym, version) {
      postAction('/sip/estimate/overview/mobile/versionEstimate', { ym, version }).then(res => {
        console.log('获取预估版本数据------', res)
        if (res.code == 200) {
          this.estimateInfo = res.result
        }
      })
    },

    // 获取ddi数据截至时间
    ddiRefreshDate() {
      getAction('/sip/bu/ddiDaily/refreshDateRealTimeRetrieval').then(res => {
        console.log('获取ddi数据截至时间------', res)
        this.ddiDate = res.result
        let ym = this.ddiDate.territoryRefreshDate
        let startTime = moment(ym)
          .startOf('month')
          .format('YYYY-MM-DD')
        let businessDate = this.ddiDate.salesBusinessDate
        let endTime = moment(businessDate)
          .subtract(1, 'year')
          .format('YYYY-MM-DD')
        let businessDays = +moment(businessDate).format('DD') // 截止日期的天数
        let monthDays = +moment(businessDate).daysInMonth() // 截止日期所在月份天数
        let dateRate = +((businessDays / monthDays) * 100).toFixed(0) // 时间进度
        // 获取去年ym
        let lastYm = moment(ym)
          .subtract(1, 'years')
          .format('YYYYMM')
        let lastStartTime = moment(lastYm)
          .startOf('month')
          .format('YYYY-MM-DD')
        // let lastEndTime = moment(lastYm).endOf('month').format('YYYY-MM-DD')
        this.getDdiInfo(ym, startTime, businessDate, dateRate)
        this.getDdiLastYear(ym, startTime, businessDate, lastYm, lastStartTime, endTime)
      })
    },
    // 获取ddi信息
    getDdiInfo(ym, startTime, endTime, dateRate) {
      postAction('/sip/bu/ddiDaily/amountSum', { ym, startTime, endTime, isTarget: this.isTarget ? 1 : null }).then(
        res => {
          console.log('获取ddi信息------', res)
          this.ddiInfo = res.result[0] || {}
          if (this.ddiInfo.yieldRate) {
            this.ddiInfo.yieldRate = +this.ddiInfo.yieldRate * 100
            this.ddiInfo.yieldRateByAmount = +this.ddiInfo.yieldRateByAmount * 100
          } else {
            this.ddiInfo.yieldRate = 0
            this.ddiInfo.yieldRateByAmount = 0
          }
          if (this.ddiInfo.targetVendorQty) {
            this.qtyText = (((this.ddiInfo.yieldRate || 0) * 100) / 100).toFixed(0) + '%'
          } else {
            this.qtyText = '-'
          }
          if (this.ddiInfo.targetAmount) {
            this.scheduleText = (((this.ddiInfo.yieldRate || 0) * 100) / 100).toFixed(0) + '%'
            this.amountText = (((this.ddiInfo.yieldRateByAmount || 0) * 100) / 100).toFixed(0) + '%'
          } else {
            this.scheduleText = '-'
            this.amountText = '-'
          }

          if (this.showQty) {
            this.scheduleText = this.qtyText
          } else {
            this.scheduleText = this.amountText
          }

          // 时间进度
          this.ddiInfo.dateSchedule = dateRate
          this.dateScheduleText = (((this.ddiInfo.dateSchedule || 0) * 100) / 100).toFixed(0) + '%'

          // 获取DDI QTD数据
          this.getDdiQtdInfo(ym, startTime, endTime)
        }
      )
    },
    // 获取ddi QTD信息
    getDdiQtdInfo(ym, startTime, endTime) {
      postAction('/sip/bu/ddiDaily/quarterAmountSum', {
        ym,
        startTime,
        endTime,
        isTarget: this.isTarget ? 1 : null
      }).then(res => {
        console.log('获取ddi QTD信息------', res)
        this.ddiQtdInfo = res.result[0] || {}
        // 保存原始值
        this.ddiQtdInfo._yieldRate = this.ddiQtdInfo.yieldRate ? +this.ddiQtdInfo.yieldRate : 0
        this.ddiQtdInfo._yieldRateByAmount = this.ddiQtdInfo.yieldRateByAmount ? +this.ddiQtdInfo.yieldRateByAmount : 0
        // 转换为百分比数值用于 circle 组件
        this.ddiQtdInfo.yieldRate = this.ddiQtdInfo._yieldRate * 100
        this.ddiQtdInfo.yieldRateByAmount = this.ddiQtdInfo._yieldRateByAmount * 100

        if (this.showQty) {
          if (this.ddiQtdInfo.targetVendorQty) {
            this.ddiQtdText = (this.ddiQtdInfo.yieldRate || 0).toFixed(0) + '%'
          } else {
            this.ddiQtdText = '-'
          }
        } else {
          if (this.ddiQtdInfo.targetAmount) {
            this.ddiQtdText = (this.ddiQtdInfo.yieldRateByAmount || 0).toFixed(0) + '%'
          } else {
            this.ddiQtdText = '-'
          }
        }
      })
    },
    // 获取ddi去年同期金额
    getDdiLastYear(ym, startTime, endTime, lastYearYm, lastYearStartTime, lastYearEndTime) {
      postAction('/sip/bu/ddiDaily/amountSumYoY', {
        ym,
        startTime,
        endTime,
        lastYearYm,
        lastYearStartTime,
        lastYearEndTime,
        isTarget: this.isTarget ? 1 : null
      }).then(res => {
        console.log('获取去年ddi信息------', res)
        if (res.code == 200) {
          this.loading = false
        }
        this.ddiLastYearInfo = res.result[0] || {}
      })
    },

    // 获取月度数据截至时间
    kpiRefreshDate() {
      getAction('/sip/bu/monthlySales/refreshDate').then(res => {
        console.log('获取月度截至时间--------', res)
        this.kpiDate = res.result
        let ym = this.kpiDate.territoryRefreshDate
        let startTime = moment(ym)
          .startOf('month')
          .format('YYYY-MM-DD')
        let endTime = moment(ym)
          .endOf('month')
          .format('YYYY-MM-DD')
        this.getKpiInfo(ym, startTime, endTime)
      })
    },
    // 获取月度信息
    getKpiInfo(ym, startTime, endTime) {
      postAction('/sip/bu/monthlySales/amountSum', { ym, startTime, endTime, isTarget: this.isTarget ? 1 : null }).then(
        res => {
          console.log('获取月度信息------', res)
          if (res.code == 200) {
            this.kpiInfo = res.result[0] || {}
            if (this.kpiInfo.yieldRate) {
              this.kpiInfo.yieldRate = +this.kpiInfo.yieldRate * 100
              this.kpiInfo.yieldRateByAmount = +this.kpiInfo.yieldRateByAmount * 100
            } else {
              this.kpiInfo.yieldRate = 0
              this.kpiInfo.yieldRateByAmount = 0
            }
            if (this.kpiInfo.targetVendorQty) {
              this.reachRateQtyText = (((this.kpiInfo.yieldRate || 0) * 100) / 100).toFixed(0) + '%'
            } else {
              this.reachRateQtyText = '-'
            }
            if (this.kpiInfo.targetAmount) {
              this.reachRateText = (((this.kpiInfo.yieldRate || 0) * 100) / 100).toFixed(0) + '%'
              this.reachRateAmountText = (((this.kpiInfo.yieldRateByAmount || 0) * 100) / 100).toFixed(0) + '%'
            } else {
              this.reachRateText = '-'
              this.reachRateAmountText = '-'
            }
            if (this.showQty) {
              this.reachRateText = this.reachRateQtyText
            } else {
              this.reachRateText = this.reachRateAmountText
            }
            // 获取去年ym
            let lastYm = moment(ym)
              .subtract(1, 'years')
              .format('YYYYMM')
            // let lastStartTime = moment(lastYm).startOf('month').format('YYYY-MM-DD')
            // let lastEndTime = moment(lastYm).endOf('month').format('YYYY-MM-DD')
            this.getKpiLastYear(ym, lastYm, this.kpiInfo.amountSum, this.kpiInfo.actualVendorQty)

            // 获取月度 QTD数据
            this.getKpiQtdInfo(ym, startTime, endTime)
          }
        }
      )
    },
    // 获取月度 QTD信息
    getKpiQtdInfo(ym, startTime, endTime) {
      postAction('/sip/bu/monthlySales/quarterAmountSum', {
        ym,
        startTime,
        endTime,
        isTarget: this.isTarget ? 1 : null
      }).then(res => {
        console.log('获取月度 QTD信息------', res)
        this.kpiQtdInfo = res.result[0] || {}
        // 保存原始值
        this.kpiQtdInfo._yieldRate = this.kpiQtdInfo.yieldRate ? +this.kpiQtdInfo.yieldRate : 0
        this.kpiQtdInfo._yieldRateByAmount = this.kpiQtdInfo.yieldRateByAmount ? +this.kpiQtdInfo.yieldRateByAmount : 0
        // 转换为百分比数值用于 circle 组件
        this.kpiQtdInfo.yieldRate = this.kpiQtdInfo._yieldRate * 100
        this.kpiQtdInfo.yieldRateByAmount = this.kpiQtdInfo._yieldRateByAmount * 100

        if (this.showQty) {
          if (this.kpiQtdInfo.targetVendorQty) {
            this.kpiQtdText = (this.kpiQtdInfo.yieldRate || 0).toFixed(0) + '%'
          } else {
            this.kpiQtdText = '-'
          }
        } else {
          if (this.kpiQtdInfo.targetAmount) {
            this.kpiQtdText = (this.kpiQtdInfo.yieldRateByAmount || 0).toFixed(0) + '%'
          } else {
            this.kpiQtdText = '-'
          }
        }
      })
    },
    // 获取月度去年同期金额
    getKpiLastYear(ym, lastYearYm, amountSum, actualVendorQty) {
      postAction('/sip/bu/monthlySales/amountSumYoY', { ym, lastYearYm, isTarget: this.isTarget ? 1 : null }).then(
        res => {
          console.log('获取去年月度信息------', res)
          this.kpiLastYearInfo = res.result[0] || {}
          // 计算yoy进度
          if (this.kpiLastYearInfo.actualVendorQty) {
            this.qtyYoy = +(
              ((actualVendorQty - this.kpiLastYearInfo.actualVendorQty) / this.kpiLastYearInfo.actualVendorQty) *
              100
            ).toFixed(0)
            this.yoyText = (((this.qtyYoy || 0) * 100) / 100).toFixed(0) + '%'
          } else {
            this.qtyYoy = 0
            this.yoyText = '-'
          }
          if (this.kpiLastYearInfo.amountSum) {
            this.amountYoy = +(
              ((amountSum - this.kpiLastYearInfo.amountSum) / this.kpiLastYearInfo.amountSum) *
              100
            ).toFixed(0)
            this.yoyText = (((this.qtyYoy || 0) * 100) / 100).toFixed(0) + '%'
          } else {
            this.amountYoy = 0
            this.yoyText = '-'
          }
          this.kpiLastYearInfo.yoy = this.qtyYoy
          if (this.showQty) {
            this.kpiLastYearInfo.yoy = this.qtyYoy
            this.yoyText = (((this.qtyYoy || 0) * 100) / 100).toFixed(0) + '%'
          } else {
            this.kpiLastYearInfo.yoy = this.amountYoy
            this.yoyText = (((this.amountYoy || 0) * 100) / 100).toFixed(0) + '%'
          }
        }
      )
    },
    // 获取流向申诉截至日期及统计月份
    getAppealDate() {
      getAction('/sip/appeal_time/getLatestAppealTimeForDashboard').then(res => {
        console.log('流向申诉截至日期--------', res)
        if (res.code == 200) {
          this.appealDate = res.result || {}
          this.getAppealStatus(this.appealDate.ym)
        }
      })
    },
    // 根据流向申诉参数月份获取状态统计
    getAppealStatus(ym) {
      postAction('/sip/appeal/status/count', { ym }).then(res => {
        console.log('流向申诉状态信息--------', res)
        if (res.code == 200) {
          this.appealStatus = res.result || {}
          this.isAppealStatus = true
        } else {
          this.isAppealStatus = false
        }
      })
    },
    // 获取运维日历
    getMaintenanceCalendar() {
      getAction('/sip/maintenanceCalendar/fileDownloadByYm', { ym: moment().format('YYYYMM') }).then(res => {
        console.log('获取运维日历--------', res)
        downFile('/system/file/download', { key: res.result }).then(r => {
          const blob = new Blob([r.data])
          const url = URL.createObjectURL(blob)
          this.calendarUrl = url
        })
      })
    },
    // 预览图片
    previewImg() {
      // 触发埋点
      this.$sensors.track('ButtonClicked', {
        $element_type: 'img',
        $url_path: '/dataBoard',
        $element_content: '运维日历图片'
      })
      this.$imagePreview([this.calendarUrl])
    },
    // 切换岗位按钮-获取助理对应的岗位列表
    getPerationalPost() {
      this.postKey = Vue.ls.get('postKey') // 获取缓存的岗位key
      getAction('/sys/sysassistantpost/getPerationalPost').then(res => {
        getAction('/sys/sysassistantpost/getChoosePost').then(r => {
          if (res.success) {
            this.postData = res.result // 岗位数据
            this.chooseIdList = r.result
            Vue.ls.set('postData', this.filteredTree)
            this.showPostDialog = true // 显示岗位选择弹窗
          }
        })
      })
    },
    deepFilter(nodes) {
      return nodes
        .map(node => {
          const newNode = { ...node } // 创建副本避免污染原始数据

          // 递归处理子节点
          if (newNode.children) {
            newNode.children = this.deepFilter(newNode.children)
          }

          // 判断保留条件：
          // 1. 当前节点在选中ID列表中
          // 2. 或处理后子节点非空
          const isMatched = this.idFilterSet.has(newNode.key)
          const hasValidChildren = newNode.children?.length > 0
          if (isMatched) {
            newNode.disabled = false // 强制启用可见节点
          } else if (hasValidChildren) {
            // 路径节点保持原有状态
            newNode.disabled = newNode.disabled ?? true
          }
          return isMatched || hasValidChildren ? newNode : null
        })
        .filter(node => node !== null)
    },
    // 选择岗位
    handleCheckChange(data, checked) {
      if (checked) {
        this.$refs.tree.setCheckedKeys([data.key]) // 强制单选逻辑
        this.selectedPostNode = data
      } else if (this.selectedPostNode && this.selectedPostNode.key === data.key) {
        this.selectedPostNode = null
      }
      this.checkedKeys = this.$refs.tree.getCheckedKeys()
    },

    switchLogin() {
      this.switchLoading = true // 切换岗位按钮禁用
      if (this.checkedKeys.length === 0 || !this.selectedPostNode) {
        this.$toast('请选择岗位')
        this.switchLoading = false // 切换岗位按钮解禁
        return
      }
      const params = {
        switchTerritoryId: this.selectedPostNode.key,
        switchUserWorkNo: this.selectedPostNode.workNo,
        switchYm: this.selectedPostNode.ym,
        jurisdictionType: this.selectedPostNode.jurisdictionType
      }
      postAction('/sys/switchLogin', params).then(res => {
        if (res.success) {
          if (res.result && res.result.token) {
            Vue.ls.set(ACCESS_TOKEN, res.result.token)
          }
          Vue.ls.set('postKey', this.checkedKeys) // 储存选择的岗位key
          this.showPostDialog = false // 显示岗位选择弹窗
          this.switchLoading = false // 切换岗位按钮解禁
          window.location.reload() // 刷新页面
        }
      })
    },
    handlePositionSwitched() {
      window.location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-collapse-item__title {
  background: none;
  padding: 0;
}
/deep/ .van-collapse-item__content {
  background: none;
  padding: 0;
}
/deep/ .is-disabled {
  display: none;
}
/deep/ .van-notice-bar {
  height: 25px;
  font-size: 12px;
}
// .van-popup {
//   color: red;
//   height: 100px !important;
// }
// .van-popover__content {
//   height: 100px !important;
//   color: red;
// }
// 切换按钮样式
.van-button {
  height: 25px;
  border-radius: 8px;
  color: #fff;
  background-color: #c0c0c0;
  border: none;
  padding: 5px;
}
.btn-active {
  z-index: 999;
  background-color: #25b4f2;
}
.ml10 {
  margin-left: 10px;
}
.ml-10 {
  margin-left: -10px;
}
.tree {
  height: 300px;
  overflow: auto;
}
::-webkit-scrollbar {
  display: none;
}
// 进度条文字样式
.schedule-text {
  width: 100%;
  height: 100%;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
// 气泡提示框
.tips {
  color: #4e7092;
  font-weight: 600;
  padding: 10px;
  // div:nth-child(2) {
  // margin-bottom: 5px;
  // text-indent: 1em;
  // }
}
.main {
  height: 100%;
  padding: 16px;
}
.ddi,
.kpi,
.estimate {
  &-title {
    font-size: 12px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.2;
    .title-left {
      display: flex;
      align-items: center;
      .logo {
        font-size: 16px;
        font-weight: 600;
        margin-right: 12px;
        display: flex;
        align-items: center;
        img {
          width: 17px;
          height: 17px;
          margin-right: 5px;
        }
      }
      .date {
        color: #7f7f7f;
        display: flex;
        align-items: center;
        span {
          margin-right: 5px;
        }
      }
    }
    .detail {
      cursor: pointer;
    }
    .sort-icon {
      transform: rotate(90deg);
      margin-left: 3px;
    }
  }
  &-content {
    width: 100%;
    height: 81px;
    background: #fff;
    border-radius: 10px;
    padding: 18px 0 22px 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .info {
      width: 30%;
      height: 100%;
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      font-size: 12px;
      .content {
        font-size: 16px;
        font-weight: 600;
        color: #4e7092;
      }
    }
    .info:nth-child(1) {
      padding-left: 10px;
    }
  }
  &-schedule {
    width: 100%;
    height: 127px;
    background: #fff;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .schedule {
      text-align: center;
      &-title {
        font-size: 12px;
        margin-bottom: 10px;
      }
    }
  }
}
.kpi-content {
  .info:nth-child(3) {
    padding-left: 15px;
  }
}
.estimate {
  .date {
    color: #ff2323 !important;
  }
  &-content {
    margin-bottom: 20px;
  }
  &-detail {
    cursor: pointer;
    text-decoration: underline;
    margin-right: 5px;
  }
  &-version-list {
    height: 200px;
    overflow: auto;
  }
  &-version {
    width: 145px;
    min-height: 35px;
    padding: 0 15px;
    font-size: 14px;
    line-height: 35px;
    text-align: center;
    color: #52658a;

    &-item {
      border-bottom: 1px solid #f7f7f9;
    }
  }
  &-version:active {
    background-color: #f2f3f5;
  }
}
.appeal {
  &-title {
    font-size: 12px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
      display: flex;
      align-items: center;
      .logo {
        font-size: 16px;
        font-weight: 600;
        margin-right: 17px;
        display: flex;
        align-items: center;
        img {
          width: 17px;
          height: 17px;
          margin-right: 5px;
        }
      }
      .date {
        color: #ff2323;
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
        }
      }
    }
  }
  &-content {
    width: 100%;
    height: 86px;
    color: #4e7092;
    background: #fff;
    border-radius: 10px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    .current {
      width: 210px;
      height: 100%;
      font-size: 12px;
      border-right: 1px solid #ccc;
      line-height: 66px;
      display: flex;
      align-items: center;
      span {
        margin-left: 28px;
        font-size: 20px;
        font-weight: 600;
      }
    }
    .all {
      width: calc(100% - 215px);
      height: 100%;
      font-size: 12px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      span {
        font-size: 16px;
        font-weight: 600;
        margin-left: 24px;
      }
    }
  }
}

.calendar {
  margin-top: 20px;
  &-title {
    font-size: 12px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left {
      display: flex;
      align-items: center;
      .logo {
        font-size: 16px;
        font-weight: 600;
        margin-right: 17px;
        display: flex;
        align-items: center;
        img {
          width: 17px;
          height: 17px;
          margin-right: 5px;
        }
      }
      .date {
        color: #7f7f7f;
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
        }
      }
    }
  }
  img {
    width: 100%;
    height: 200px;
    object-fit: contain;
  }
  .non-img {
    height: 50px;
    text-align: center;
    line-height: 50px;
  }
}

// 岗位切换按钮
.switch-post {
  width: 45px;
  height: 45px;
  font-size: 12px;
  color: #fff;
  padding: 10px;
  background-image: url(/appeal_btn.png);
  background-size: cover;
  position: fixed;
  right: 15px;
  bottom: 100px;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  .missing {
    display: flex;
    align-items: center;
    justify-content: center;
    // div {
    //   margin-left: 10px;
    //   cursor: pointer;
    //   &:first-child {
    //     color: #25b6ee;
    //   }
    // }
  }
}
</style>
